var _effectorFileName = "/builds/gmini/ui-common/src/FileValidationErrorsPopup/FileValidationErrorsPopup.tsx";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import { Popup } from '../Popup';
import { IconButton } from '../IconButton';
import { Wrapper, RoundedCross, Header, Title, ErrorsWrapper, ErrorMessage } from './FileValidationErrorsPopup.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FileValidationErrorsPopup = function FileValidationErrorsPopup(_ref) {
  var errors = _ref.errors,
      _onClose = _ref.onClose,
      open = _ref.open;
  return /*#__PURE__*/_jsx(Popup, {
    width: "600px",
    onClose: function onClose() {
      return _onClose(false);
    },
    open: open,
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsxs(Header, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: Number(errors === null || errors === void 0 ? void 0 : errors.length) > 1 ? 'Некоторые файлы не были прикреплены' : 'Файл не был прикреплен'
        }), /*#__PURE__*/_jsx(IconButton, {
          type: "square",
          children: /*#__PURE__*/_jsx(RoundedCross, {
            onClick: function onClick() {
              return _onClose(false);
            }
          })
        })]
      }), /*#__PURE__*/_jsx(ErrorsWrapper, {
        children: errors === null || errors === void 0 ? void 0 : errors.map(function (error, idx) {
          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            _jsx(ErrorMessage, {
              children: error
            }, idx)
          );
        })
      })]
    })
  });
};